export default "__VITE_ASSET__DAK2ecGW__"